import axios from "axios"
import { CONST_API_BUSINESS_CONSULTANT_GET_ASSURANCES_ENDPOINT } from "../../../../../endpoints"
import { IGetAssurancesRequestModel, IGetAssurancesResponseModel } from "./_models"

export function getAssurancesListingRequest(payload: IGetAssurancesRequestModel) {
     return axios.post<IGetAssurancesResponseModel>(CONST_API_BUSINESS_CONSULTANT_GET_ASSURANCES_ENDPOINT, payload)
}
